import React, { useState } from 'react';
import { Body, BodyType, BodyColor, Heading, TypographyType, TypographyColor } from '../../../ui-elements';

interface RankData {
    rank: number | null;
    normalizedScore: number | null;
    color: string;
    filteredOut?: boolean;
}

interface RankCellProps {
    data: RankData | null;
}

export const RankCell: React.FC<RankCellProps> = ({ data }) => {
    const [isHovered, setIsHovered] = useState(false);

    if (!data) return <span>NA</span>;

    if (data.filteredOut) {
        return (
            <Body type={BodyType.p2} color={BodyColor.primary} classname="p-0">
                Filtered Out
            </Body>
        );
    }

    if (data.rank === null || data.rank === undefined) {
        return (
            <div
                className="position-relative"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <span>NA</span>

                {/* Tooltip for null rank */}
                {isHovered && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '150%',
                            left: '0%',
                            transform: 'translateX(0)',
                            zIndex: 9999,
                        }}
                    >
                        <div
                            style={{
                                position: 'relative',
                                backgroundColor: '#fff',
                                padding: '10px 16px',
                                borderRadius: '12px',
                                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                                fontSize: '14px',
                                color: '#333',
                                whiteSpace: 'normal',
                                textAlign: 'left',
                                minWidth: '180px',
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    left: '12px',
                                    width: 0,
                                    height: 0,
                                    borderLeft: '8px solid transparent',
                                    borderRight: '8px solid transparent',
                                    borderBottom: '8px solid #fff',
                                }}
                            />
                            <Body
                                type={BodyType.p3}
                                color={BodyColor.secondary}
                                classname="p-0"
                            >
                                {"We can't rank this region because data for your selected parameters is missing."}
                            </Body>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="d-flex align-items-center gap-2">
            {/* Rank badge */}
            <Heading
                title={data.rank}
                type={TypographyType.h6}
                colour={TypographyColor.primary}
                classname="rankRecommended"
                style={{ backgroundColor: data.color || '#E0E0E0' }}
            />
            {/* Normalized score */}
            <Body type={BodyType.p2} color={BodyColor.primary} classname="p-0">
                {data.normalizedScore !== null ? data.normalizedScore : 'NA'}
            </Body>
        </div>
    );
};
